module.exports = __webpack_public_path__ + "static/media/bg-dog-collar.a2606f39.webp";